module.exports = __webpack_public_path__ + "static/media/replicate-mobile.27b2b542.svg";